import { CLOSE, SCREEN } from '../../utils/constants';
import { t } from '../../utils/i18n';
import {
    clearLocationDropdown,
    clearProcedureDropdown,
    clearProviderDropdown,
    isValidFullName,
    loadCustomFields,
    toggleLocationDropdown,
    toggleSelectProcedure,
    toggleSelectProvider,
} from '../actions/consultActions';
import validator from 'validator';
import {
    emailOptin,
    leadInfo,
    locationId,
    locations,
    procedureId,
    procedures,
    providerId,
    providers,
    noPreferenceSelected,
    setNoPreferenceSelected,
    selectedCountry,
    selectedLanguage,
    setEmailOptin,
    setLocationId,
    setProcedureId,
    setProviderId,
    setSelectedLanguage,
    sourceParam,
    visitorId,
    isInInstantQuote,
    setIsInstantQuote,
    phone,
    fullName,
    selectedProcedures,
    email,
    emailCheck,
    setLeadInfo,
    form,
    setLeadTextId,
    setCustomField,
    customField,
    appUrl,
    fileUploadChannel,
    setProcedures,
    setFirstQuestion,
    setProgressQuestion,
    staffId,
    procedureIdSelected,
    showSubscribedToOffersOption,
    appointmentChannelId,
    isDisableSearchService,
    isFlowForCalendar,
    isOTPTimeOut,
    setPhone,
    setFullName,
    setEmail,
    setTempLeadInfo,
    a2pConsentEnabled,
    smsConsentTransactional,
    smsConsentPromotional,
    termsAndPrivacyAccepted,
    setSmsConsentTransactional,
    setSmsConsentPromotional,
    setTermsAndPrivacyAccepted,
    businessName,
    leadTextId,
    consultDobStepDone,
    setConsultDobStepDone,
} from '../../utils/variables';
import { toggleLoading } from '../actions/loading';
import { createLead, updateLeadStep } from '../../services/leadServices';
import { navigate, openBookAppointment, params } from './movePages';
import parsePhoneNumberFromString, {
    isValidPhoneNumber,
} from 'libphonenumber-js';
import {
    formatPhoneNumber,
    toggleCountriesConsult,
    validatePhoneNumber,
} from '../actions/countryCodeActions';
import { toastError } from '../../views/components/error';
import { loadSelectSearchProcedure } from '../../views/components/selectSearchProcedure';
import { loadProvidersDropdown } from '../../views/components/providersDropdown';
import { loadLocationsDropdown } from '../../views/components/locationsDropdown';
import { loadConsultDetail } from '../../views/pages/consultSummary';
import { getProceduresByStaffId } from '../../services/procedureServices';
import { updateVisitorAction } from '../../services/visitorServices';

import { uploadPhotosListeners } from './uploadPhotosListeners';
import { preSelectProcedure } from './surgicalListeners';
import { sendOTPCodeWithTimer } from '../actions/validateDigitsActions';
import { loadCategoryList } from '../../views/pages/categories';
import { categorySelectionListeners } from './categorySelectionListeners';
import { isHasProcedureBelongToCategory } from '../actions/categoryActions';
import { categories, setProcedures as setProceduresVar, setQuestionnaireFields, setQuestionnaireFormId, setListDataQuestion, setListNamePageQuestion, setCustomFields, setAppointmentQuestionsCompleted, preQuestionnairePhotosDone, setPreQuestionnairePhotosDone } from '../../utils/variables';
import { loadAllQuestionsFlow, shouldShowAllQuestions } from '../actions/allQuestionsFlow';
import { updateLeadPortal } from '../../services/digitsCodeService';
import { renderDobDropdowns } from '../../views/components/dobDropdowns';
import { filterFieldsForProcedures, shouldStepConsultFields } from '../../utils/qualificationVisibility';

var consultSimpleConsentChecked = false;

// Tokens describing the visitor's selected procedure, for per-procedure
// consult question gating (fieldMatchesProcedures): the preselected id (URL
// param), its resolved name, and whatever the consult form's procedure input
// holds. Config `procedures` arrays may list names or ids.
function getSelectedProcedureTokens() {
    const tokens = [];
    if (procedureId) {
        tokens.push(procedureId);
        const match = (procedures || []).find((p) => String(p?.id) === String(procedureId));
        if (match?.name) tokens.push(match.name);
    }
    const typed = document.querySelector('#procedureConsult')?.value;
    if (typed) tokens.push(typed);
    return tokens;
}

function buildLastFormSubmission() {
    // Only build last_form_submission when there are actual custom questions configured.
    // Standard lead fields (name/email/phone/service) are already captured on the lead
    // record and are redundant here. Return null when no custom questions exist so the
    // backend keeps last_form_submission null (finishedQualificationForm stays false).
    const consultFields = !isFlowForCalendar && Array.isArray(form?.consult_request_fields)
        ? form.consult_request_fields
        : [];
    if (consultFields.length === 0) {
        return null;
    }

    const fields = [];
    const pushField = (name, label, value, placeholder = '') => {
        fields.push({
            name,
            label,
            value: value ?? '',
            placeholder: placeholder ?? ''
        });
    };

    consultFields.forEach((field) => {
        const fieldId = `customField__${field.id}`;
        const input = document.querySelector(`#${CSS.escape(fieldId)}`);
        if (!input) return;
        const label = field.label || t('custom_field');
        const placeholder = input.placeholder || label || '';
        pushField(field.id, label, input.value, placeholder);
    });

    // When widget runs inside iframe (assistant.pilotpractice.com), use the embedding page URL
    // for analytics so page_url reflects the real site (e.g. luxeskinmedspa.com), not the iframe.
    let pageUrl = window.location.href;
    const sourceParamVal = params('source');
    const domainParamVal = params('domain');
    const pathParamVal = params('path');
    const isAssistantIframe = /assistant\.pilotpractice\.com/i.test(window.location.hostname);
    if (isAssistantIframe && (sourceParamVal || (domainParamVal && pathParamVal))) {
        if (sourceParamVal && (sourceParamVal.startsWith('http://') || sourceParamVal.startsWith('https://'))) {
            pageUrl = sourceParamVal.split('#')[0];
        } else if (domainParamVal && pathParamVal) {
            const path = pathParamVal.startsWith('/') ? pathParamVal : '/' + pathParamVal;
            pageUrl = `https://${domainParamVal.replace(/^https?:\/\//, '').split('/')[0]}${path}`;
        }
    }

    if (fields.length === 0) {
        return null;
    }

    return {
        fields,
        url: pageUrl,
        ...(visitorId && { visitor_id: visitorId }),
    };
}

export function scheduleListeners() {
    /* on change inputs */
    const inputs = document.querySelectorAll(
        '.requestConsult__container input, .requestConsult__container select'
    );
    const isCategoryEnabled = form?.appointment_channel?.enable_category_selection;

    const emailOptionWrapper = document.querySelector('.requestConsult__container .emailOptin__wrapper')
    if (emailOptionWrapper) {
        if (emailOptionWrapper) {
            emailOptionWrapper.classList.toggle('hide', !showSubscribedToOffersOption);
        }
    }

    inputs.forEach((i) => {
        i.addEventListener('keydown', (event) => {
            if (event.key === 'Tab') {
                event.stopPropagation();
            }
        });
    });

    inputs.forEach((i) => {
        const clearInvalid = () => {
            const dataForm = i.getAttribute('id');
            document
                .querySelector(
                    `.requestConsult__container div[data-form="${CSS.escape(
                        dataForm
                    )}"]`
                )
                .classList.remove('invalid');
            maybeEnableRequestConsultButton();
        };
        i.oninput = clearInvalid;
        i.addEventListener('change', clearInvalid);
    });

    /* on validate name */
    validateName();

    function selectedLocation() {
        document
            .querySelector(
                '.requestConsult__container div[data-form="locationConsult"'
            )
            ?.classList.remove('invalid');

        document
            .querySelector(
                '.requestConsult__container .locationsDropdown__wrapper'
            )
            ?.classList.add('selected');
    }

    /* Locations dropdown */
    if (locations.length > 1 && (!appointmentChannelId)) {
        if (staffId && locationId) {
            const locationConsultElement =
                document.querySelector('#locationConsult');
            if (locationConsultElement) {
                locationConsultElement.value = locations?.find(l => l.id === locationId)?.name;
            }
            setLocationId(locationId);
            selectedLocation();
        } else {
            locationDropdown();
        }
    } else if (locations.length === 1 || (appointmentChannelId && locationId)) {
        const foundLocation = locations.find((l) => l.id === locationId);
        const locationConsultElement =
            document.querySelector('#locationConsult');
        if (locationConsultElement) {
            locationConsultElement.value = (foundLocation || locations[0])?.name;
        }
        setLocationId((foundLocation || locations[0])?.id);
        selectedLocation();
    }

    if (appointmentChannelId && locations?.length > 1) {
        locationDropdown();
    }

    /* providers dropdown */
    if (providers.length > 1 && !staffId && !isCategoryEnabled) {
        providerDropdown();
    }

    /* Procedure dropdown */
    procedureDropdown();

    /* on change & validate email */
    validateEmail();

    /* on format & validate phone number */
    validatePhone();

    /* on check email optin */
    onCheckEmailOptin();

    /* Show/hide consent blocks based on a2p_consent_enabled setting */
    updateConsultConsentText();
    const a2pWrapper = document.querySelector('.requestConsult__container .requestConsult__a2p-consent');
    const simpleWrapper = document.querySelector('.requestConsult__container .requestConsult__simple-consent');
    if (a2pConsentEnabled) {
        if (a2pWrapper) a2pWrapper.style.display = '';
        if (simpleWrapper) simpleWrapper.style.display = 'none';
        const promotionalRow = document.querySelector('.requestConsult__container .sms-consent-promotional-row');
        if (promotionalRow) {
            promotionalRow.style.display = showSubscribedToOffersOption ? '' : 'none';
        }
        if (!showSubscribedToOffersOption) {
            setSmsConsentPromotional(false);
        }
    } else {
        if (a2pWrapper) a2pWrapper.style.display = 'none';
        if (simpleWrapper) simpleWrapper.style.display = '';
        // Passive consent — no checkbox needed, auto-grant on form display
        consultSimpleConsentChecked = true;
        setSmsConsentTransactional(true);
        setTermsAndPrivacyAccepted(true);
    }

    /* on check request consult consent (A2P) */
    onCheckRequestConsultConsent();

    /* custom consult field validation */
    setupCustomConsultFieldValidation();
    maybeEnableRequestConsultButton();

    // Hide specific form fields when scheduling requires collecting patient information first.
    const shouldCollectPatientInfoFirst = form?.appointment_channel?.collect_patient_information_first_before_scheduling;

    if (shouldCollectPatientInfoFirst && appointmentChannelId) {
        const fieldsToHide = [
            'location__dropdown',
            'provider__dropdown',
            'procedure__wrapper'
        ];

        const selector = fieldsToHide.map(field => `.requestConsult__container .${field}`).join(', ');
        document.querySelectorAll(selector).forEach(element => {
            element.classList.add('hidden');
        });

        document.querySelector('.requestConsult__container .back-arrow').classList.add('hidden');
    }

    // Hide procedure field if is_category_enabled is true, or when the widget
    // itself is configured to hide the service selector (hide_select_procedure_field).
    if (isCategoryEnabled || form?.hide_select_procedure_field) {
        const procedureWrapper = document.querySelector('.requestConsult__container .procedure__wrapper');
        if (procedureWrapper) {
            procedureWrapper.classList.add('hidden');
        }
    }

    /* On click enter */
    const screenPhone = document.querySelector('.requestConsult__container');
    if (screenPhone) {
        screenPhone.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                document
                    .querySelector(
                        '.requestConsult__container .requestConsult__btn'
                    )
                    .click();
            }
        });
    }

    /*
    On click Request Consultation button 
    */
    document
        .querySelectorAll('.requestConsult__container .requestConsult__btn')
        .forEach((i) => {
            i.onclick = (e) => {
                e.preventDefault();
                const btnRequestConsult = e.target.closest(
                    '.requestConsult__btn'
                );
                const loaderIcon =
                    btnRequestConsult.querySelector('.loader__icon');
                btnRequestConsult.classList.add('disabled', 'hover');
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.style.display = 'flex';
                    loaderIcon.insertAdjacentHTML(
                        'beforeend',
                        `<img src="${appUrl}/assets/icons/rolling.png" />`
                    );
                }
                let error = false;
                let inputs = document.querySelectorAll(
                    '.requestConsult__container .form-control'
                );

                const fields = ['location__dropdown', 'provider__dropdown', 'procedure__wrapper'];
                const { collect_patient_information_first_before_scheduling } = form?.appointment_channel || {}
                if (collect_patient_information_first_before_scheduling && appointmentChannelId) {
                    inputs = Array.from(inputs).filter(input =>
                        !fields.some(field => input.closest(`.${field}`))
                    );
                }

                const isCategoryEnabled = form?.appointment_channel?.enable_category_selection;
                if (isCategoryEnabled) {
                    inputs = Array.from(inputs).filter(input =>
                        !input.closest('.procedure__wrapper') &&
                        !input.closest('.provider__dropdown')
                    );
                }

                for (const i of inputs) {
                    const dataForm = i.getAttribute('data-form');
                    if (!dataForm) {
                        continue;
                    }
                    const input = document.querySelector(
                        `.requestConsult__container div[data-form="${CSS.escape(
                            dataForm
                        )}"] #${CSS.escape(dataForm)}`
                    );
                    if (!input) {
                        continue;
                    }

                    if (input.getAttribute('id') === 'insuranceConsult') {
                        continue;
                    }

                    if (input?.getAttribute('id') === 'procedureConsult' && (isCategoryEnabled || form?.hide_select_procedure_field)) {
                        continue;
                    }

                    if (
                        (!input.value || (isDisableSearchService && input.getAttribute('id') === 'procedureConsult' && !procedureId)) ||
                        (input.getAttribute('id') === 'emailConsult' &&
                            !validator.isEmail(input.value)) ||
                        (input.getAttribute('id') === 'phoneConsult' &&
                            !isValidPhoneNumber(
                                input.value,
                                selectedCountry
                            )) ||
                        (input.getAttribute('id') === 'nameConsult' &&
                            !isValidFullName(input.value))
                    ) {
                        i.classList.add('invalid');
                        error = true;
                    }
                }
                if (error) {
                    addLoadingBtnRequestConsult(
                        btnRequestConsult,
                        loaderIcon
                    )();
                    return;
                }
                if (!isCategoryEnabled && providers.length > 0) {
                    const provider = providers.find((i) => i.id === providerId);
                    let procedure = procedures.filter(
                        (i) => i.id === procedureId
                    );

                    if (!procedureId && !isDisableSearchService) {
                        let textProcedureInput = document.querySelector('#procedureConsult').value;
                        procedure = [
                            {
                                name: textProcedureInput
                            }
                        ];
                    }

                    const requiresPatientInfoFirst = form?.appointment_channel?.collect_patient_information_first_before_scheduling || false;

                    const shouldConsultDetail = appointmentChannelId && requiresPatientInfoFirst;

                    // `provider` can be undefined when the provider field is
                    // hidden and none was selected/assigned. Skip the provider
                    // summary in that case — handleRequestConsultation still
                    // submits and omits provider_id.
                    if (!shouldConsultDetail && provider) {
                        loadConsultDetail(provider, procedure);
                    }

                    handleRequestConsultation(addLoadingBtnRequestConsult(
                        btnRequestConsult,
                        loaderIcon
                    ));
                } else handleRequestConsultation(addLoadingBtnRequestConsult(
                    btnRequestConsult,
                    loaderIcon
                ));
            };
        });

    /* On click enter */
    const screenConsultSummary = document.querySelector('.consultSummary__container');
    if (screenConsultSummary) {
        screenConsultSummary.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                document
                    .querySelector(
                        '.consult-summary__btn'
                    )
                    .click();
            }
        });
    }

    /* On click Still interested, request a consultation  */
    document.querySelector(
        '.consultSummary__container .consult-summary__btn'
    ).onclick = (e) => {
        e.preventDefault();
        handelConsultSummaryBtn();
    };
}

function addLoadingBtnRequestConsult(btn, loader) {
    return () => {
        btn?.classList.remove('disabled');
        loader.style.display = 'none';
        loader.innerHTML = '';
    };
}

function providerDropdown() {
    const wrapper = document.querySelector('.provider__dropdown .providersDropdown__wrapper');
    if (!wrapper) return;
    
    document.querySelector(
        '.provider__dropdown .providersDropdown__wrapper div'
    ).onclick = () => toggleSelectProvider();

    document.querySelector('#providerConsultDownArrow').onclick = () => {
        toggleSelectProvider();
    };

    document.querySelector('#providerConsultUpArrow').onclick = () => {
        toggleSelectProvider(CLOSE);
    };

    /* Click outside to close provider dropdown */
    document.addEventListener('click', handleClickOutsideProvidersDropdown);

    /* on search providers */
    document
        .querySelector('#providerConsult')
        .addEventListener('input', (e) => {
            const oninput = document.querySelector('.providersDropdown__wrapper');
            if (oninput && !oninput.classList.contains('open')) {
                oninput.classList.add('open');
            }
            document
                .querySelector('.providersDropdown__wrapper')
                .classList.remove('selected');

            setProviderId('');

            const value = e.target.value;

            const newProviders = providers.filter((i) => {
                const name = i.first_name + ' ' + i.last_name;

                return name.toLowerCase().includes(value.toLowerCase());
            });

            loadProvidersDropdown(newProviders);
        });
}

async function handleClickOutsideProvidersDropdown(evt) {
    const element = document.querySelector('.providersDropdown__wrapper');
    let targetElement = evt.target;

    do {
        if (targetElement == element) {
            return;
        }
        targetElement = targetElement.parentNode;
    } while (targetElement);

    toggleSelectProvider(CLOSE);

    if (!providerId && !noPreferenceSelected) {
        clearProviderDropdown();
    }
}

export function handleSelectProvider() {
    /* Click provider option */
    document.querySelectorAll('.providersDropdown__option').forEach((i) => {
        i.onclick = () => {
            const name = i.getAttribute('data-provider');
            const rawId = i.getAttribute('data-provider-id');
            const avt = i.getAttribute('data-avt');
            // Empty data-provider-id = the "No preference" option: pass null so no
            // staff_id is sent and the full service list (not staff-scoped) loads.
            const id = rawId === '' || rawId === null ? null : parseInt(rawId);

            selectProviderInDropdown(id, name, avt);
        };
    });
}

export async function selectProviderInDropdown(id, name, avt) {
    toggleSelectProvider(CLOSE);

    setProviderId(id);
    // Remember a deliberate "No preference" pick (id === null) so a later
    // click-outside doesn't mistake it for "nothing selected" and clear it.
    setNoPreferenceSelected(id == null);

    const provider = providers.find((j) => j.id === id);

    const title = provider?.title || '';

    document.querySelector('#providerConsult').value = name;

    document
        .querySelector(
            '.requestConsult__container div[data-form="providerConsult"'
        )
        .classList.remove('invalid');

    document
        .querySelector('.providersDropdown__wrapper')
        .classList.add('selected');

    document
        .querySelector('.providersDropdown__wrapper .provider__selected-avt')
        .setAttribute('src', avt);

    document.querySelector(
        '.providersDropdown__wrapper .provider__selected-title'
    ).innerHTML = title || '';

    document.querySelector('#procedureConsult').disabled = true;

    try {
        let newProcedures;

        if (id == null) {
            // "No preference": not scoped to any provider, so show the full
            // service list rather than fetching by staff id.
            newProcedures = appointmentChannelId
                ? (form?.appointment_channel?.procedures || [])
                : procedures;
        } else {
            const response = await getProceduresByStaffId(id);
            newProcedures = response.data.data;

            if (appointmentChannelId) {
                const newProcedureIds = newProcedures.map((i) => i.id);
                newProcedures = form?.appointment_channel?.procedures?.filter((i) => newProcedureIds.includes(i.id));
            }
        }

        loadSelectSearchProcedure(newProcedures);
        setProcedures(newProcedures);
        clearProcedureDropdown();
        if (procedureIdSelected) {
            preSelectProcedure();
        }
        maybeEnableRequestConsultButton();
    } catch (err) {
        toastError(err.response?.data?.message || t('server_error_generic'));
    } finally {
        document.querySelector('#procedureConsult').disabled = false;
    }
}

function locationDropdown() {
    const location = document.querySelector('#locationConsult');

    location.onclick = () => toggleLocationDropdown();

    /* Click outside to close location dropdown */
    document.addEventListener('click', (evt) => {
        const element = document.querySelector('.locationsDropdown__wrapper');
        let targetElement = evt.target;

        do {
            if (targetElement == element) {
                return;
            }
            targetElement = targetElement.parentNode;
        } while (targetElement);

        toggleLocationDropdown(CLOSE);
        if (!locationId) {
            clearLocationDropdown();
        }
    });

    /* on search location */
    location.addEventListener('input', (e) => {
        const value = e.target.value;

        setLocationId('');

        const newLocations = locations.filter((i) => {
            return i.name.toLowerCase().includes(value.toLowerCase());
        });

        loadLocationsDropdown(newLocations);
    });
}

export function handleSelectLocation() {
    document.querySelectorAll('.locations-dropdown__option').forEach((i) => {
        i.onclick = () => {
            const name = i.getAttribute('data-location');
            const id = parseInt(i.getAttribute('data-location-id'));

            setLocationId(id);

            const locationConsultElement =
                document.querySelector('#locationConsult');
            if (locationConsultElement) {
                locationConsultElement.value = name;
            }

            document
                .querySelector(
                    '.requestConsult__container div[data-form="locationConsult"'
                )
                .classList.remove('invalid');

            document
                .querySelector(
                    '.requestConsult__container .locationsDropdown__wrapper'
                )
                .classList.add('selected');

            toggleLocationDropdown(CLOSE);

            if (providers.length > 1) {
                const newProviders = providers.filter(
                    (i) => i.location_ids?.includes(id)
                );

                loadProvidersDropdown(newProviders);

                clearProviderDropdown();
            }

            document.querySelector('#procedureConsult').value = '';
            maybeEnableRequestConsultButton();
        };
    });
}

function validateName() {
    const name = document.querySelector('#nameConsult');
    const nameWrap = document.querySelector(
        '.requestConsult__container div[data-form="nameConsult"]'
    );

    const applyNameValidation = (value) => {
        if (isValidFullName(value)) {
            nameWrap.classList.add('valid');
            nameWrap.classList.remove('invalid');
        } else {
            nameWrap.classList.remove('valid');
            nameWrap.classList.add('invalid');
        }
    };

    name.oninput = (e) => {
        applyNameValidation(e.target.value);
        maybeEnableRequestConsultButton();
    };

    name.addEventListener('blur', (e) => {
        applyNameValidation((e.target.value || '').trim());
    });
}

export function handleSelectProcedure() {
    /* on select procedure */
    const options = document.querySelectorAll(
        '.requestConsult__container .procedure__menu .procedure__option'
    );
    options.forEach((i) => {
        i.onclick = () => {
            if (visitorId) {
                updateVisitorAction(visitorId, 'selected-service', {
                    procedure_id: parseInt(i.getAttribute('data-procedure-id')),
                }).catch(error => {
                    console.error('Failed to track procedure selection:', error);
                });
            }

            document.querySelector('#procedureConsult').value = i.textContent;

            document
                .querySelector(
                    '.requestConsult__container div[data-form="procedureConsult"'
                )
                .classList.remove('invalid');

            document
                .querySelector('.requestConsult__container .procedure__wrapper')
                .classList.add('selected');

            toggleSelectProcedure(CLOSE);

            setProcedureId(parseInt(i.getAttribute('data-procedure-id')));
            maybeEnableRequestConsultButton();
        };
    });
}

function procedureDropdown() {
    /* toggle dropdown procedure */
    document.querySelector('#procedureConsult').onclick = () => {
        toggleSelectProcedure();
    };

    document.querySelector('#procedureConsultDownArrow').onclick = () => {
        toggleSelectProcedure();
    };

    /* Click outside to close procedure menu */
    document.addEventListener('click', (evt) => {
        const element = document.getElementById('procedure-wrapper');
        let targetElement = evt.target;

        do {
            if (targetElement == element) {
                return;
            }
            targetElement = targetElement.parentNode;
        } while (targetElement);

        toggleSelectProcedure(CLOSE);
    });

    // Click up arrow icon to close procedure menu
    document.querySelector('#procedureConsultUpArrow').onclick = () => {
        toggleSelectProcedure(CLOSE);
    };

    /* On search procedure */
    let searchDebounceTimer;
    document.querySelector('#procedureConsult').oninput = (e) => {
        if (searchDebounceTimer) {
            clearTimeout(searchDebounceTimer);
        }

        searchDebounceTimer = setTimeout(() => {
            if (visitorId && e.target.value) {
                updateVisitorAction(visitorId, 'selected-service', {
                    procedure_search: e.target.value,
                }).catch(error => {
                    console.error('Failed to track procedure search:', error);
                });
            }
        }, 500);

        const oninput = document.querySelector('.providersDropdown__wrapper');
        if (oninput) {
            oninput.classList.remove('open');
        }
        const oninputProcedure = document.querySelector('.procedure__wrapper.dropdown');
        if (oninputProcedure) {
            oninputProcedure.classList.add('open');
        }
        setProcedureId('');

        const value = e.target.value;
        const { procedures: proceduresAppointmentChannel } = form?.appointment_channel || {};

        const newProcedures = (appointmentChannelId ? proceduresAppointmentChannel : procedures).filter((i) =>
            i.name.toLowerCase().includes(value.toLowerCase())
        );

        loadSelectSearchProcedure(newProcedures);
        if (e.target.value && !isDisableSearchService) {
            document
                .querySelector('.requestConsult__container .procedure__wrapper')
                .classList.add('selected');
        } else {
            document
                .querySelector('.requestConsult__container .procedure__wrapper')
                .classList.remove('selected');
        }
        maybeEnableRequestConsultButton();
    };
}

function validateEmail() {
    const email = document.querySelector('#emailConsult');
    const emailWrap = document.querySelector(
        '.requestConsult__container div[data-form="emailConsult"]'
    );

    const applyEmailValidation = (value) => {
        if (validator.isEmail(value)) {
            emailWrap.classList.add('valid');
            emailWrap.classList.remove('invalid');
        } else {
            emailWrap.classList.remove('valid');
            emailWrap.classList.add('invalid');
        }
    };

    email.oninput = (e) => {
        applyEmailValidation(e.target.value);
        maybeEnableRequestConsultButton();
    };

    email.addEventListener('blur', (e) => {
        applyEmailValidation((e.target.value || '').trim());
    });
}

function validatePhone() {
    const phone = document.querySelector('#phoneConsult');
    const phoneWrapper = document.querySelector(
        '.requestConsult__container div[data-form="phoneConsult"]'
    );

    phone.oninput = (e) => {
        const newValue = formatPhoneNumber(e.target.value, selectedCountry);
        phone.value = newValue;
        validatePhoneNumber(phoneWrapper, e.target.value);
        maybeEnableRequestConsultButton();
    };

    phone.addEventListener('blur', () => {
        validatePhoneNumber(phoneWrapper, phone.value);
    });

    /* toggle country code phone number */
    document.querySelector(
        `.phone__selected-code.${SCREEN.REQUEST_CONSULT}`
    ).onclick = () => toggleCountriesConsult();
}

function setupCustomConsultFieldValidation() {
    const fields = document.querySelectorAll(
        '.requestConsult__container .custom-consult-fields input, .requestConsult__container .custom-consult-fields select, .requestConsult__container .custom-consult-fields textarea'
    );

    fields.forEach((field) => {
        const wrapper = field.closest('.form-control');
        if (!wrapper) return;

        const updateState = () => {
            const value = (field.value || '').trim();
            if (value) {
                wrapper.classList.add('valid');
                wrapper.classList.remove('invalid');
            } else {
                wrapper.classList.remove('valid');
            }
            maybeEnableRequestConsultButton();
        };

        field.addEventListener('input', updateState);
        field.addEventListener('change', updateState);
    });
}

export function maybeEnableRequestConsultButton() {
    const button = document.querySelector(
        '.requestConsult__container .requestConsult__btn'
    );
    if (!button) return;
    if (isRequestConsultFormValid()) {
        button.classList.remove('disabled');
    } else {
        button.classList.add('disabled');
    }
}

function isRequestConsultFormValid() {
    let inputs = document.querySelectorAll(
        '.requestConsult__container .form-control'
    );
    const fields = ['location__dropdown', 'provider__dropdown', 'procedure__wrapper'];
    const { collect_patient_information_first_before_scheduling } =
        form?.appointment_channel || {};
    if (collect_patient_information_first_before_scheduling && appointmentChannelId) {
        inputs = Array.from(inputs).filter(input =>
            !fields.some(field => input.closest(`.${field}`))
        );
    }

    const isCategoryEnabled = form?.appointment_channel?.enable_category_selection;
    if (isCategoryEnabled) {
        inputs = Array.from(inputs).filter(input =>
            !input.closest('.procedure__wrapper') &&
            !input.closest('.provider__dropdown')
        );
    }

    for (const wrapper of inputs) {
        const dataForm = wrapper.getAttribute('data-form');
        if (!dataForm) {
            continue;
        }
        const input = document.querySelector(
            `.requestConsult__container div[data-form="${CSS.escape(
                dataForm
            )}"] #${CSS.escape(dataForm)}`
        );

        if (!input) {
            continue;
        }

        const inputId = input.getAttribute('id');
        if (inputId === 'insuranceConsult') {
            continue;
        }
        if (inputId === 'procedureConsult' && (isCategoryEnabled || form?.hide_select_procedure_field)) {
            continue;
        }

        const value = (input.value || '').trim();
        if (!value) {
            return false;
        }
        if (
            inputId === 'procedureConsult' &&
            isDisableSearchService &&
            !procedureId
        ) {
            return false;
        }
        if (inputId === 'emailConsult' && !validator.isEmail(value)) {
            return false;
        }
        if (
            inputId === 'phoneConsult' &&
            !isValidPhoneNumber(value, selectedCountry)
        ) {
            return false;
        }
        if (inputId === 'nameConsult' && !isValidFullName(value)) {
            return false;
        }
    }

    // Check consent — only terms & privacy is required; SMS checkboxes are optional
    if (a2pConsentEnabled) {
        if (!termsAndPrivacyAccepted) return false;
    } else {
        if (!consultSimpleConsentChecked) return false;
    }

    return true;
}

function onCheckEmailOptin() {
    const checkBox = document.querySelector(
        '.requestConsult__container .emailOptin__checkbox'
    );

    if (!checkBox) return;
    checkBox.onclick = () => {
        if (checkBox.classList.contains('is-checked')) {
            checkBox.classList.remove('is-checked');
            setEmailOptin(false);
        } else {
            checkBox.classList.add('is-checked');
            setEmailOptin(true);
        }
    };
}

function onCheckRequestConsultConsent() {
    const container = document.querySelector('.requestConsult__container');
    if (!container) return;

    if (a2pConsentEnabled) {
        const transactionalCheckbox = container.querySelector('.sms-consent-transactional-checkbox');
        const promotionalCheckbox = container.querySelector('.sms-consent-promotional-checkbox');
        const termsPrivacyCheckbox = container.querySelector('.terms-privacy-checkbox');
        const transactionalRow = container.querySelector('.sms-consent-transactional-row');
        const promotionalRow = container.querySelector('.sms-consent-promotional-row');
        const termsPrivacyRow = container.querySelector('.terms-privacy-row');

        const handleTransactionalClick = (e) => {
            e.preventDefault();
            if (transactionalCheckbox) {
                transactionalCheckbox.classList.toggle('is-checked');
                setSmsConsentTransactional(transactionalCheckbox.classList.contains('is-checked'));
                transactionalRow?.classList.remove('invalid');
                maybeEnableRequestConsultButton();
            }
        };

        const handlePromotionalClick = (e) => {
            e.preventDefault();
            if (promotionalCheckbox) {
                promotionalCheckbox.classList.toggle('is-checked');
                setSmsConsentPromotional(promotionalCheckbox.classList.contains('is-checked'));
                maybeEnableRequestConsultButton();
            }
        };

        const handleTermsPrivacyClick = (e) => {
            if (e.target.closest('.terms-link') || e.target.closest('.privacy-link')) return;
            e.preventDefault();
            if (termsPrivacyCheckbox) {
                termsPrivacyCheckbox.classList.toggle('is-checked');
                setTermsAndPrivacyAccepted(termsPrivacyCheckbox.classList.contains('is-checked'));
                termsPrivacyRow?.classList.remove('invalid');
                maybeEnableRequestConsultButton();
            }
        };

        if (transactionalRow && transactionalCheckbox) {
            transactionalRow.style.cursor = 'pointer';
            transactionalRow.onclick = handleTransactionalClick;
            transactionalCheckbox.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleTransactionalClick(e); }
            });
        }
        if (promotionalRow && promotionalCheckbox) {
            promotionalRow.style.cursor = 'pointer';
            promotionalRow.onclick = handlePromotionalClick;
            promotionalCheckbox.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handlePromotionalClick(e); }
            });
        }
        if (termsPrivacyRow && termsPrivacyCheckbox) {
            termsPrivacyRow.style.cursor = 'pointer';
            termsPrivacyRow.onclick = handleTermsPrivacyClick;
            termsPrivacyCheckbox.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleTermsPrivacyClick(e); }
            });
        }
    }
    // When A2P is disabled, consent is passive (no checkbox) — already auto-granted on init
}

function updateConsultConsentText() {
    const businessNameSpans = document.querySelectorAll(
        '.requestConsult__container .sms-consent-business-name'
    );
    const practiceNameText = businessName || '[Business Name]';
    businessNameSpans.forEach((span) => {
        span.textContent = practiceNameText;
    });
}

export function showCategorySelectionForConsultation(proceduresToShow) {
    const filteredCategories = categories.filter((category) =>
        isHasProcedureBelongToCategory(category, proceduresToShow)
    );

    if (filteredCategories.length > 0) {
        setProceduresVar(proceduresToShow);
        loadCategoryList(filteredCategories);
        categorySelectionListeners();
        navigate(SCREEN.CATEGORIES);
        return true;
    }
    return false;
}

async function handleRequestConsultation(addLoadingBtnRequestConsult) {
    toggleLoading(true);

    if (isInInstantQuote) {
        const validPhone = parsePhoneNumberFromString(phone, selectedCountry);
        const sourceSelectValue = document.querySelector('#sourceConsult')?.value;
        const resolvedSource = sourceSelectValue || sourceParam;
        const data = {
            full_name: fullName,
            phone: validPhone.number,
            procedures_interested_in: selectedProcedures,
            email: email,
            email_optin: emailCheck,
            ...(locationId && { location_id: locationId }),
            ...(providerId && { provider_id: providerId }),
            ...(resolvedSource && { source: resolvedSource }),
            ...(visitorId && { visitor_id: visitorId }),
            ...(selectedLanguage && { language: selectedLanguage }),
        };

        try {
            const res = await createLead(data);
            setLeadTextId(res.data.text_id);
            const lead = res.data;
            setLeadInfo(lead);
            toggleLoading(false);
            setIsInstantQuote(false);
            document
                .querySelector('.endScreen__container')
                ?.classList?.add('show-the-end-screen');
            document.getElementById('consult-summary')?.focus();
            if (providers?.length > 0) {
                navigate(SCREEN.CONSULT_SUMMARY);
            } else {
                handelConsultSummaryBtn();
            }
        } catch (err) {
            toastError(err?.response?.data?.message);
            toggleLoading(false);
            return;
        } finally {
            addLoadingBtnRequestConsult();
        }
    } else {
        const phone = parsePhoneNumberFromString(
            document.querySelector('#phoneConsult').value,
            selectedCountry
        );
        const sourceSelectValue = document.querySelector('#sourceConsult')?.value;
        const resolvedSource = sourceSelectValue || sourceParam;
        const typedName = document.querySelector('#nameConsult')?.value || '';
        const typedEmail = document.querySelector('#emailConsult')?.value || '';
        const typedPhoneDisplay = document.querySelector('#phoneConsult')?.value || '';
        // Persist what they typed so the slot → intake handoff can prefill
        // without reading the matched chart (household PHI).
        if (typedName) setFullName(typedName);
        if (typedEmail) setEmail(typedEmail);
        if (typedPhoneDisplay) setPhone(typedPhoneDisplay);

        const data = {
            full_name: typedName,
            phone: phone.number,
            ...(procedureId && { procedures_interested_in: [procedureId] }),
            email: typedEmail,
            email_optin: emailOptin,
            sms_consent_transactional: smsConsentTransactional,
            sms_consent_promotional: smsConsentPromotional,
            terms_and_privacy_accepted: termsAndPrivacyAccepted,
            ...(locationId && { location_id: locationId }),
            ...(providerId && { provider_id: providerId }),
            ...(resolvedSource && { source: resolvedSource }),
            ...(visitorId && { visitor_id: visitorId }),
            ...(selectedLanguage && { language: selectedLanguage }),
            last_form_submission: buildLastFormSubmission(),
        };

        const dobValue = document.querySelector('#dobConsult')?.value;
        if (dobValue) {
            data.date_of_birth = dobValue;
        }

        const genderValue = document.querySelector('#genderConsult')?.value;
        if (genderValue) {
            data.gender = genderValue;
        }

        const insurance =
            (document.querySelector('#insuranceConsult')?.value ||
                document.querySelector('#insurance')?.value ||
                ''
            ).trim();

        if (insurance) {
            data.insurance = insurance;
        }

        const procedureValue = document.querySelector('#procedureConsult')?.value;
        if (!procedureId && procedureValue) {
            data.procedure = procedureValue;
        }

        try {
            const { collect_patient_information_first_before_scheduling } = form?.appointment_channel || {}
            const { is_phone_otp_enabled } = form || {}
            const isCategoryEnabled = form?.appointment_channel?.enable_category_selection;

            if (isCategoryEnabled) {
                const proceduresToShow = appointmentChannelId 
                    ? (form?.appointment_channel?.procedures || procedures)
                    : procedures;
                
                if (is_phone_otp_enabled && data.phone) {
                    toggleLoading(false);
                    setIsInstantQuote(false);
                    setTempLeadInfo(data);
                    await navigateToValidateDigits(data.phone);
                    return;
                } else {
                    toggleLoading(false);
                    setIsInstantQuote(false);
                    setTempLeadInfo(data);
                    if (showCategorySelectionForConsultation(proceduresToShow)) {
                        addLoadingBtnRequestConsult();
                        return;
                    }
                }
            } else {
                if (is_phone_otp_enabled && data.phone) {
                    toggleLoading(false);
                    setIsInstantQuote(false);
                    setTempLeadInfo(data)
                    await navigateToValidateDigits(data.phone);
                    return;
                } else {
                    const res = await createLead(data);
                    setLeadTextId(res.data.text_id);
                    const lead = res.data;
                    setLeadInfo(lead);
                    toggleLoading(false);
                    setIsInstantQuote(false);
                    document.getElementById('consult-summary')?.focus();
                    const isCalendarAppointmentFlow = appointmentChannelId
                        && form?.appointment_request_type === 'calendar';
                    // Calendar appointment-channel flow: choose slot first, then questionnaire.
                    if (isCalendarAppointmentFlow) {
                        // Set on_page immediately so EndWidgetSessions cron can catch
                        // drop-offs during calendar/time selection screens.
                        updateLeadStep(lead.id, 'login', '');

                        // Show questionnaire before calendar if setting is enabled
                        const showQuestionnaireBefore = form?.appointment_channel?.show_questionnaire_before_scheduling;
                        if (showQuestionnaireBefore) {
                            const qualificationFields = Array.isArray(form?.appointment_channel?.qualification_form?.custom_fields)
                                ? form.appointment_channel.qualification_form.custom_fields
                                : [];
                            if (qualificationFields.length > 0) {
                                // upload_before (card photo → skip to type policy/member ID)
                                // only runs on the one-per-page path, not all-questions.
                                if (qualificationFields.some((f) => f?.upload_before)) {
                                    setListDataQuestion({});
                                    setListNamePageQuestion([]);
                                    setQuestionnaireFields(qualificationFields);
                                    setQuestionnaireFormId(form?.appointment_channel?.qualification_form?.id);
                                    setProgressQuestion({
                                        currentQuestion: 1,
                                        total: qualificationFields.length,
                                        progress: (1 / qualificationFields.length) * 100,
                                    });
                                    setCustomField(qualificationFields[0]);
                                    setFirstQuestion(true);
                                    loadCustomFields(qualificationFields[0]);
                                    return;
                                }
                                if (shouldShowAllQuestions()) {
                                    setCustomFields(qualificationFields);
                                    loadAllQuestionsFlow();
                                    return;
                                }
                            }
                        }

                        openBookAppointment();
                        return;
                    }
                    // Photos-first flow: collect photo uploads BEFORE the questionnaire,
                    // then hand off to handelConsultSummaryBtn to start it.
                    if (
                        fileUploadChannel?.channelable?.before_questionnaire &&
                        !preQuestionnairePhotosDone
                    ) {
                        uploadPhotosListeners(() => {
                            setPreQuestionnairePhotosDone(true);
                            handelConsultSummaryBtn();
                        });
                        navigate(SCREEN.UPLOAD_PHOTOS);
                        return;
                    }
                    const consultRequestFields = !isFlowForCalendar && Array.isArray(form?.consult_request_fields)
                        ? form.consult_request_fields
                        : [];
                    if (shouldStepConsultFields(consultRequestFields)) {
                        const forProcedure = filterFieldsForProcedures(consultRequestFields, getSelectedProcedureTokens());
                        if (forProcedure.length > 0) {
                            setListDataQuestion({});
                            setListNamePageQuestion([]);
                            const normalized = forProcedure.map((f) => ({
                                ...f,
                                title: f.title || f.label || t('custom_field'),
                            }));
                            setQuestionnaireFields(normalized);
                            setQuestionnaireFormId(form?.consult_request_form_id ?? null);
                            setProgressQuestion({
                                currentQuestion: 1,
                                total: normalized.length,
                                progress: (1 / normalized.length) * 100,
                            });
                            await updateLeadStep(lead.id, 'consult', '');
                            setCustomField(normalized[0]);
                            setFirstQuestion(true);
                            loadCustomFields(normalized[0]);
                            return;
                        }
                    }
                    // qualification_form custom_fields only apply to calendar flow
                    const isFormFlow = form?.appointment_request_type === 'form';
                    const qualificationFields = !isFormFlow && Array.isArray(form?.appointment_channel?.qualification_form?.custom_fields)
                        ? form.appointment_channel.qualification_form.custom_fields
                        : [];
                    if (qualificationFields.length > 0) {
                        setQuestionnaireFields(qualificationFields);
                        setQuestionnaireFormId(form?.appointment_channel?.qualification_form?.id);
                        setProgressQuestion({
                            currentQuestion: 1,
                            total: qualificationFields.length,
                            progress: ((1 / qualificationFields.length) * 100)
                        });
                        await updateLeadStep(lead.id, 'consult', '');
                        setCustomField(qualificationFields[0]);
                        setFirstQuestion(true);
                        loadCustomFields(qualificationFields[0]);
                        return;
                    }
                    if (collect_patient_information_first_before_scheduling && appointmentChannelId) {
                        if (isFlowForCalendar) {
                            updateLeadStep(leadInfo.id, 'login', 'true');
                        }
                        openBookAppointment()
                        return;
                    }
                    handelConsultSummaryBtn();
                }
            }
        } catch (err) {
            console.log(err);
            toastError(err?.response?.data?.message);
            toggleLoading(false);
            return;
        } finally {
            addLoadingBtnRequestConsult();
        }
    }
}

export async function handelConsultSummaryBtn() {
    const isCalendarAppointmentFlow = appointmentChannelId
        && form?.appointment_request_type === 'calendar';
    if (isCalendarAppointmentFlow) {
        openBookAppointment();
        return;
    }

    // Photos-first flow: collect photo uploads BEFORE the questionnaire,
    // then re-enter this function to start the questionnaire.
    if (
        fileUploadChannel?.channelable?.before_questionnaire &&
        !preQuestionnairePhotosDone
    ) {
        uploadPhotosListeners(() => {
            setPreQuestionnairePhotosDone(true);
            handelConsultSummaryBtn();
        });
        navigate(SCREEN.UPLOAD_PHOTOS);
        return;
    }

    // Priority 1: consult_request_fields (consult request form flow only, not calendar)
    const consultRequestFields = !isFlowForCalendar && Array.isArray(form?.consult_request_fields)
        ? form.consult_request_fields
        : [];
    if (shouldStepConsultFields(consultRequestFields)) {
        const forProcedure = filterFieldsForProcedures(consultRequestFields, getSelectedProcedureTokens());
        if (forProcedure.length > 0) {
            setListDataQuestion({});
            setListNamePageQuestion([]);
            const normalized = forProcedure.map((f) => ({
                ...f,
                title: f.title || f.label || t('custom_field'),
            }));
            setQuestionnaireFields(normalized);
            setQuestionnaireFormId(form?.consult_request_form_id ?? null);
            setProgressQuestion({
                currentQuestion: 1,
                total: normalized.length,
                progress: (1 / normalized.length) * 100,
            });
            await updateLeadStep(leadInfo.id, 'consult', '');
            setCustomField(normalized[0]);
            setFirstQuestion(true);
            loadCustomFields(normalized[0]);
            return;
        }
    }

    // Priority 2: qualification_form custom_fields (calendar flow only)
    const isFormFlow = form?.appointment_request_type === 'form';
    const qualificationFields = !isFormFlow && Array.isArray(form?.appointment_channel?.qualification_form?.custom_fields)
        ? form.appointment_channel.qualification_form.custom_fields
        : [];
    if (qualificationFields.length > 0) {
        setQuestionnaireFields(qualificationFields);
        setQuestionnaireFormId(form?.appointment_channel?.qualification_form?.id);
        setProgressQuestion({
            currentQuestion: 1,
            total: qualificationFields.length,
            progress: ((1 / qualificationFields.length) * 100)
        });
        await updateLeadStep(leadInfo.id, 'consult', '');
        setCustomField(qualificationFields[0]);
        setFirstQuestion(true);
        loadCustomFields(qualificationFields[0]);
        return;
    }

    // Single-pager DOB split: the consult request form was the whole flow and
    // DOB is required — collect it on its own step before the end screen. The
    // lead already exists, so a drop-off here still leaves a complete contact.
    if (shouldSplitDobStep() && !consultDobStepDone && !leadInfo?.date_of_birth) {
        showConsultDobStep();
        return;
    }

    if (fileUploadChannel && !preQuestionnairePhotosDone) {
        uploadPhotosListeners();
        navigate(SCREEN.UPLOAD_PHOTOS);
    } else {
        navigate(SCREEN.THE_END);
    }
}

/**
 * Single-pager consult request form + DOB: instead of cramming the DOB
 * dropdowns into the one-page form, defer them to a dedicated second step
 * shown right after the form submits. Only applies when the consult REQUEST
 * form is the entire flow — calendar flows, prebook patient-info, category
 * selection, multi-step questionnaires (>2 consult fields) and photo-upload
 * flows keep the inline DOB field (rendered by sheduleConsult.js).
 */
export function shouldSplitDobStep() {
    const isFormOnlyFlow = !isFlowForCalendar && form?.appointment_request_type !== 'calendar';
    const isPrebookPatientInfo = appointmentChannelId
        && form?.appointment_channel?.collect_patient_information_first_before_scheduling;
    const consultRequestFields = Array.isArray(form?.consult_request_fields)
        ? form.consult_request_fields
        : [];
    const hasPhotoUpload = Boolean(fileUploadChannel)
        && !(Array.isArray(fileUploadChannel) && fileUploadChannel.length === 0);
    return Boolean(
        form?.show_dob_field &&
        isFormOnlyFlow &&
        !isInInstantQuote &&
        !isPrebookPatientInfo &&
        !form?.appointment_channel?.enable_category_selection &&
        !shouldStepConsultFields(consultRequestFields) &&
        !hasPhotoUpload
    );
}

let consultDobSaving = false;

function showConsultDobStep() {
    const container = document.querySelector('.consultDob__container');
    if (!container) {
        navigate(SCREEN.THE_END);
        return;
    }

    container.querySelector('.consultDob__title').textContent = t('dob_step_title');
    container.querySelector('.consultDob__subtitle').textContent = t('dob_step_subtitle');
    const btn = container.querySelector('.consultDob__btn');
    btn.querySelector('.text').textContent = t('continue');

    if (!container.querySelector('#dobStepInput')) {
        renderDobDropdowns(container.querySelector('.dob__consult'), {
            inputId: 'dobStepInput',
            idPrefix: 'dobStep',
            onChange: (value) => btn.classList.toggle('disabled', !value),
        });
        btn.addEventListener('click', handleConsultDobContinue);
    }

    navigate(SCREEN.CONSULT_DOB);
}

async function handleConsultDobContinue() {
    const btn = document.querySelector('.consultDob__btn');
    const dob = document.getElementById('dobStepInput')?.value;
    if (!dob || consultDobSaving || btn?.classList.contains('disabled')) return;

    consultDobSaving = true;
    btn.classList.add('disabled');
    const loaderIcon = btn.querySelector('.loader__icon');
    if (loaderIcon) {
        loaderIcon.innerHTML = `<img src="${appUrl}/assets/icons/rolling.png" />`;
    }

    try {
        const targetTextId = leadInfo?.text_id || leadTextId;
        await updateLeadPortal(targetTextId, { date_of_birth: dob });
        // WidgetLeadResource doesn't echo date_of_birth — merge it locally so
        // re-entry into handelConsultSummaryBtn sees it as collected.
        setLeadInfo({ ...(leadInfo || {}), date_of_birth: dob });
        setConsultDobStepDone(true);
        handelConsultSummaryBtn();
    } catch (err) {
        console.log(err);
        toastError(err?.response?.data?.message);
        btn.classList.remove('disabled');
    } finally {
        consultDobSaving = false;
        if (loaderIcon) loaderIcon.innerHTML = '';
    }
}

async function navigateToValidateDigits(phone) {
    setPhone(phone);
    if (isOTPTimeOut) {
        await sendOTPCodeWithTimer();
    }
    document.getElementById('validateDigits0').focus();
    navigate(SCREEN.VALIDATE_DIGITS);
    const phoneNumObj = parsePhoneNumberFromString(
        phone,
        'US'
    );
    if (
        document.querySelector(
            '.validateDigits--sub-title strong'
        )
    ) {
        document.querySelector(
            '.validateDigits--sub-title strong'
        ).innerHTML = phoneNumObj.number;
    }
}